import { createAction } from '@reduxjs/toolkit';
import { SharePayload } from './types';

export const shareDocument = createAction<SharePayload>('documents/share');
export const qrCodeShareDocument = createAction<SharePayload>('documents/qrshare');
